"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = exports.AlertProvider = exports.AlertContext = exports.AlertType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
var AlertType;
(function (AlertType) {
    AlertType["Success"] = "success";
    AlertType["Error"] = "error";
    AlertType["Info"] = "info";
    AlertType["Warn"] = "warning";
})(AlertType || (exports.AlertType = AlertType = {}));
exports.AlertContext = (0, react_1.createContext)({ showAlert: () => { } });
const AlertProvider = ({ children, }) => {
    const [alert, setAlert] = (0, react_1.useState)(null);
    const showAlert = (0, react_1.useCallback)((message, type) => {
        setAlert({ message, type });
    }, []);
    const handleClose = (0, react_1.useCallback)(() => {
        setAlert(null);
    }, []);
    const value = react_1.default.useMemo(() => ({ showAlert }), [showAlert]);
    return ((0, jsx_runtime_1.jsxs)(exports.AlertContext.Provider, { value: value, children: [children, alert && ((0, jsx_runtime_1.jsx)(material_1.Snackbar, { open: true, autoHideDuration: 3000, onClose: handleClose, anchorOrigin: { vertical: "bottom", horizontal: "center" }, children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: alert.type, children: alert.message }) }))] }));
};
exports.AlertProvider = AlertProvider;
const useAlert = () => react_1.default.useContext(exports.AlertContext);
exports.useAlert = useAlert;
